<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Pagar préstamo</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Cuentas por pagar</a></li>
                <li class="breadcrumb-item active">Pagar préstamo</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-body">
                <tabs class="tabs-default" :options="{ defaultTabHash: 'Pagar' }">
                    <tab id="pagar" name="Pagar">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-7">
                                    <tabs class="tabs-default" :options="{ defaultTabHash: 'Efectivo' }"
                                    v-if="payments.length>0">
                                        <tab name="Efectivo"
                                            :is-disabled="payments[getIndexWithName(payments,'Efectivo')].status">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Pagado</label>
                                                    <masked-input
                                                        v-model="payments[getIndexWithName(payments,'Efectivo')].amountTurned"
                                                        ref="efectivoInput" type="text" class="form-control"
                                                        :mask="mask_quetzal" :guide="false" :keep-char-positions="true"
                                                        :show-mask="true" @blur="addAllTypesOfPayments()" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cambio</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Efectivo')].amountPaid"
                                                        type="text" class="form-control" readonly="true" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cuenta</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Efectivo')].account">
                                                        <option
                                                            v-for="item in payments[getIndexWithName(payments,'Efectivo')].accounts"
                                                            :key="item.id" :value="item">
                                                            {{item.name}} / {{mymoney(item.amount)}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        v-model="payments[getIndexWithName(payments,'Efectivo')].description"
                                                        rows="5" class="form-control">
                                                    </textarea>
                                                </div>
                                            </div>
                                        </tab>
                                        <tab name="Cheque"
                                            :is-disabled="payments[getIndexWithName(payments,'Cheque')].status">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Cantidad</label>
                                                    <masked-input
                                                        v-model="payments[getIndexWithName(payments,'Cheque')].amount"
                                                        ref="efectivoInput" type="text" class="form-control"
                                                        :mask="mask_quetzal" :guide="false" :keep-char-positions="true"
                                                        :show-mask="true" @blur="addAllTypesOfPayments()" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cuenta</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Cheque')].account">
                                                        <option
                                                            v-for="item in payments[getIndexWithName(payments,'Cheque')].accounts"
                                                            :key="item.id" :value="item">
                                                            {{item.name}} / {{mymoney(item.amount)}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>No.Cheque</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Cheque')].ChequeNumber"
                                                        class="form-control" type="text" />
                                                </div>
                                                <bank :item="getIndexWithName(payments,'Cheque')"
                                                    :variable="'ChequeNameBank'" @update-bank="updateBank" />
                                                <div class="form-group">
                                                    <label>Mismo banco</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Cheque')].ChequeSameBank">
                                                        <option value="1">Si</option>
                                                        <option value="0">No</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        v-model="payments[getIndexWithName(payments,'Cheque')].description"
                                                        rows="5" class="form-control"></textarea>
                                                </div>
                                            </div>
                                        </tab>
                                        <tab name="Depósito"
                                            :is-disabled="payments[getIndexWithName(payments,'Depósito')].status">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Cantidad</label>
                                                    <masked-input
                                                        v-model="payments[getIndexWithName(payments,'Depósito')].amount"
                                                        ref="efectivoInput" type="text" class="form-control"
                                                        :mask="mask_quetzal" :guide="false" :keep-char-positions="true"
                                                        :show-mask="true" @blur="addAllTypesOfPayments()" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cuenta</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Depósito')].account">
                                                        <option
                                                            v-for="item in payments[getIndexWithName(payments,'Depósito')].accounts"
                                                            :key="item.id" :value="item">
                                                            {{item.name}} / {{mymoney(item.amount)}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>No.Depósito</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Depósito')].DepositNumber"
                                                        class="form-control" type="text" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        v-model="payments[getIndexWithName(payments,'Depósito')].description"
                                                        rows="5" class="form-control"></textarea>
                                                </div>
                                            </div>
                                        </tab>
                                        <tab name="Tarjeta de Crédito/Debito"
                                            :is-disabled="payments[getIndexWithName(payments,'Transferencia')].status">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Cantidad</label>
                                                    <masked-input
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].amount"
                                                        ref="efectivoInput" type="text" class="form-control"
                                                        :mask="mask_quetzal" :guide="false" :keep-char-positions="true"
                                                        :show-mask="true" @blur="addAllTypesOfPayments()" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cuenta</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].account">
                                                        <option
                                                            v-for="item in payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].accounts"
                                                            :key="item.id" :value="item">
                                                            {{item.name}} / {{mymoney(item.amount)}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>No.Transacción</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardNumber"
                                                        class="form-control" type="text" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Nombre de tarjeta</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardName"
                                                        class="form-control" type="text" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Ultimos 4 dígitos de la tarjeta</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].CardLast4digits"
                                                        class="form-control" type="text" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        v-model="payments[getIndexWithName(payments,'Tarjeta de Crédito/Debito')].description"
                                                        rows="5" class="form-control"></textarea>
                                                </div>
                                            </div>
                                        </tab>
                                        <tab name="Transferencia"
                                            :is-disabled="payments[getIndexWithName(payments,'Transferencia')].status">
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Cantidad</label>
                                                    <masked-input
                                                        v-model="payments[getIndexWithName(payments,'Transferencia')].amount"
                                                        ref="efectivoInput" type="text" class="form-control"
                                                        :mask="mask_quetzal" :guide="false" :keep-char-positions="true"
                                                        :show-mask="true" @blur="addAllTypesOfPayments()" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Cuenta</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Transferencia')].account">
                                                        <option
                                                            v-for="item in payments[getIndexWithName(payments,'Transferencia')].accounts"
                                                            :key="item.id" :value="item">
                                                            {{item.name}} / {{mymoney(item.amount)}}</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>No.Transferencia</label>
                                                    <input
                                                        v-model="payments[getIndexWithName(payments,'Transferencia')].TransferNumber"
                                                        class="form-control" type="text" />
                                                </div>
                                                <bank :item="getIndexWithName(payments,'Transferencia')"
                                                    :variable="'TransferNameBank'" @update-bank="updateBank" />
                                                <div class="form-group">
                                                    <label>Mismo banco</label>
                                                    <select class="form-control"
                                                        v-model="payments[getIndexWithName(payments,'Transferencia')].TransferSameBank">
                                                        <option value="1">Si</option>
                                                        <option value="0">No</option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Descripción</label>
                                                    <textarea
                                                        v-model="payments[getIndexWithName(payments,'Transferencia')].description"
                                                        rows="5" class="form-control"></textarea>
                                                </div>
                                            </div>
                                        </tab>
                                    </tabs>
                                    <div class="spinner-border" role="status" v-else>
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="row">
                                        <!-- <div class="container">
                                            <div class="row justify-content-center">
                                                <h6>Proveedor</h6>
                                            </div>
                                        </div>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td class="font-weight-bold">Proveedor: </td>
                                                    <td>{{typeof(provider.company)!=='undefined'?provider.company:'Seleccione un proveedor'}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bold">Crédito autorizado: </td>
                                                    <td>{{mymoney(typeof(provider.credit_limit)!=='undefined'?provider.credit_limit:0)}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bold">Límete de días: </td>
                                                    <td>{{typeof(provider.day_limit)!=='undefined'?provider.day_limit:'No aplica'}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table> -->
                                        <div class="container">
                                            <div class="row justify-content-center">
                                                <h6>Pagos</h6>
                                            </div>
                                        </div>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo de pago</th>
                                                    <th>Cantidad</th>
                                                    <th>Cuenta</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="payment in paymentWithAmount" :key="payment.id">
                                                    <td>{{payment.name}}</td>
                                                    <td>{{payment.amount}}</td>
                                                    <td v-if="payment.account!=0">{{payment.account.name}}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td class="font-weight-bold">Monto total</td>
                                                    <td colspan="2">{{mymoney(totalChequer)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bold">Total a pagar</td>
                                                    <td colspan="2">{{mymoney(total)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bold"
                                                        :class="subtraction(total,totalChequer)===0 ? 'bg-success':'bg-danger'">
                                                        Pendiente</td>
                                                    <td :class="subtraction(total,totalChequer)===0 ? 'bg-success':'bg-danger'"
                                                        colspan="2">
                                                        {{mymoney(subtraction(total,totalChequer))}}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button slot="button" class="btn btn-block btn-theme"
                                            @keyup.enter="openToPay"
                                            @click="openToPay">Cambiar monto de pago</button>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button slot="button" class="btn btn-block btn-theme ladda-button"
                                            data-style="expand-right" ref="buttonSave" @keyup.enter="saveAll"
                                            @click="saveAll">Guardar pago</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabs>
            </div>
        </div>
        <sweet-modal ref="modal_loan" title="Monto a cancelar" hide-close-button blocking>
            <!-- BEGIN FORM -->
            <div class="card-body">
                <div class="form-group">
                    <label>Fecha</label>
                    <datepicker 
                        :format="format" 
                        input-class="form-control" 
                        :language="es"
                        v-model="datePayment" />
                </div>
                <div class="form-group">
                    <label>Saldo</label>
                    <input 
                        class="form-control"
                        :value="mymoney(typeof(loan.balance)==='undefined'?'0':loan.balance)"
                        readonly='true'>
                </div>
                <div class="form-group">
                    <label>Monto</label>
                    <masked-input
                        v-model="totalString"
                        type="text" 
                        class="form-control"
                        :mask="mask_quetzal" 
                        :guide="false" 
                        :keep-char-positions="true"
                        :show-mask="true"/>
                </div>
            </div>
            <button slot="button" type="button" class="btn btn-danger"
                @click="cancelPay">Cancelar</button>
            <button slot="button" type="button" class="btn btn-primary"
                @click="saveToPay">Guardar</button>
            <!-- END FORM -->
        </sweet-modal>
    </div>
</template>
<script>
    import { Tabs, Tab } from 'vue-tabs-component'
    import Datepicker from 'vuejs-datepicker'
    import { en, es } from 'vuejs-datepicker/dist/locale'
    import Multiselect from 'vue-multiselect'
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
    import ladda from "ladda";
    import { required, between } from "vuelidate/lib/validators";
    import { xelacode } from '../../../helpers/xelacode'
    import MaskedInput from 'vue-text-mask'
    import createNumberMask from 'text-mask-addons/dist/createNumberMask'
    import { TableComponent, TableColumn } from "vue-table-component";
    import Bank from '../utils/Bank';
    
    export default {
        components: {
            'tabs': Tabs,
            'tab': Tab,
            Datepicker,
            'masked-input': MaskedInput,
            'bank': Bank,
            SweetModal,
            SweetModalTab,
        },
        data(){
            return{
                format: 'dd/MM/yyyy',
                en: en,
                es: es,
                loan:{},
                payments:[],
                totalChequer:0,
                mask_quetzal: createNumberMask({
                    prefix: 'Q ',
                    suffix: '',
                    includeThousandsSeparator: true,
                    thousandsSeparatorSymbol: ',',
                    allowDecimal: true,
                    decimalSymbol: '.',
                    decimalLimit: 2, // how many digits allowed after the decimal
                    integerLimit: 10, // limit length of integer numbers
                    allowNegative: false,
                    allowLeadingZeroes: false,
                }),
                total:0,
                totalString:'',
                datePayment:new Date().toISOString().slice(0,10),
                user:{}
            }
        },
        computed: {
            paymentWithAmount() {
                return this.payments.filter(x => x.amount != "");
            }
        },
        methods:{
            setData(value){
                let list=[];
                list.push(value);
                return list[0];
            },
            // METHOD REF TI INPUT VUE
            changeRefVue(nameRef) {
                this.$refs[nameRef].$el.focus();
            },
            // METHOD TO REF
            changeRef(nameRef) {
                this.$refs[nameRef].focus();
            },
            changeRefInput(nameRef) {
                this.$refs[nameRef].focus();
            },
            refMultiple(input, item) {
                let inputLength = this.selectProducts.length - 1;
                if (item > inputLength) {
                    this.changeRef('description');
                } else {
                    this.changeRefInput(`${input}-${item}`);
                }
            },
            // METHOD NUMBERS TWO DECIMAL
            parseDecimal(value) {
                return parseFloat(this.parseDecimalFixed(value));
            },
            parseDecimalFixed(value) {
                return parseFloat(value).toFixed(2);
            },
            // METHOD QUETZALES
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
            myquantity(value) {
                return xelacode.quantity(value);
            },
            getLoan(){
                let vm=this;
                axios.get(`/api/admin/outgoingloan/getLoan/${vm.$route.query.id}`)
                    .then((response)=>{
                        vm.loan=response.data;
                        vm.$refs.modal_loan.open();
                        vm.getPayments();
                    }).catch((error)=>{
                        console.log(error)
                    })
            },
            getPayments() {
                let me = this;
                var url = `/api/admin/outgoingloan/getPayments`;
                axios.get(url).then(function (response) {
                    me.payments = response.data;
                    me.getAccounts();
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getAccounts() {
                let me = this;
                me.payments.forEach((item, index) => {
                    var url = `/api/admin/outgoingloan/getAccounts?place=${me.loan.idplace}&payment=${item.name}`;
                    axios.get(url)
                    .then(function (response) {
                        me.payments[index].accounts = response.data;
                        if (me.payments[index].accounts === 0)
                            me.payments[index].accounts = [];
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                });
            },
            getIndexWithName(list, name) {
                return list.findIndex(x => x.name === name);
            },
            updateBank(value, item, variable) {
                this.payments[item][variable] = value;
            },
            subtraction(A, B) {
                return this.parseDecimal(this.parseDecimal(A) - this.parseDecimal(B))
            },
            saveAll(){
                let me=this;
                let validate=false;
                me.payments.forEach((item,index) => {
                    if(item.name==="Efectivo"){
                        if(item.amountTurned!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en efectivo','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Cheque"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en cheque','Error')
                                validate=true;
                                return;
                            }
                            else if(item.ChequeNumber==""){
                                toastr.error('Ingrese un número de cheque','Error')
                                validate=true;
                                return;
                            }
                            else if(item.ChequeNameBank==""){
                                toastr.error('Seleccione un banco en crédito','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Depósito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en depósito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.DepositNumber==""){
                                toastr.error('Ingrese un número de transacción en depósito','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Tarjeta de Crédito/Debito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en tarjeta de Crédito/Debito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardNumber==""){
                                toastr.error('Ingrese el número de transacción en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardName==""){
                                toastr.error('Ingrese el nombre del propietario en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardLast4digits==""){
                                toastr.error('Ingrese lo últimos 4 dígitos en tarjeta','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Tarjeta de Crédito/Debito"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en tarjeta de Crédito/Debito','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardName==""){
                                toastr.error('Ingrese el nombre del propietario en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardNumber==""){
                                toastr.error('Ingrese el número de transacción en tarjeta','Error')
                                validate=true;
                                return;
                            }
                            else if(item.CardLast4digits==""){
                                toastr.error('Ingrese lo últimos 4 dígitos en tarjeta','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                    else if(item.name==="Transferencia"){
                        if(item.amount!=""){
                            if(item.account==""){
                                toastr.error('Seleccione una cuenta en transferencia','Error')
                                validate=true;
                                return;
                            }
                            else if(item.TransferNumber==""){
                                toastr.error('Ingrese el número de transacción en transferencia','Error')
                                validate=true;
                                return;
                            }
                            else if(item.TransferNameBank==""){
                                toastr.error('Seleccione un banco en transferencia','Error')
                                validate=true;
                                return;
                            }
                        }
                    }
                });
                if(validate===true){
                    return;
                }
                if(this.provider===''){
                    toastr.error('Para pagar la compra, seleccione a un proveedor','Error')
                    validate=true;
                }
                if(validate===true){
                    return; 
                }
                if(this.subtraction(this.total,this.totalChequer)!=0){
                    toastr.error('Para pagar la compra la cantidad pendiente deber ser igual a 0','Error')
                    validate=true;
                }
                if(validate===true){
                    return; 
                }
                me.payments.forEach((element,index) => {
                    if(element.amount!=""){
                        if(String(element.amount).includes('Q'))
                            me.payments[index].amountString=me.parseDecimal(me.converMaskToNumber(element.amount));
                    }
                });
                var l = ladda.create(document.querySelector(".ladda-button"));
                    l.start();
                    axios.post('/api/admin/outgoingloan/store',{
                        loan:JSON.stringify(me.loan),
                        amount:me.total,
                        payoutDate:me.datePayment,
                        payments: JSON.stringify(me.payments),
                        user: JSON.stringify(me.user)
                    }).then((response)=>{
                        toastr.success(response.data.message, "Listo");
                        me.$router.push({path:'/admin/cuentasporpagar/lista'})
                        l.stop();
                    }).catch((error)=>{
                        toastr.error(error.response.data.message, "Error");
                        l.stop();
                    });
                
            },
            addAllTypesOfPayments() {
                this.totalChequer = 0;
                let me = this;
                var listTemporary = [];
                var totalWithOutEfectivo=0;
                this.payments.forEach((payment, index) => {
                    if (payment.status === 0) {
                        var numberTemporary = 0;
                        if (payment.amount !== ""&&payment.name!="Efectivo"){
                            numberTemporary = me.parseDecimal(me.converMaskToNumber(payment.amount));
                            totalWithOutEfectivo+=numberTemporary;
                        }else if(payment.name==="Efectivo"){
                            var amountTurned=me.parseDecimal(me.converMaskToNumber(payment.amountTurned));
                            if(isNaN(amountTurned))
                                amountTurned=0;
                            var amountPaid=me.subtraction(amountTurned,me.subtraction(me.total,totalWithOutEfectivo));
                            if(amountPaid<0){
                                me.payments[index].amountPaid=me.mymoney(0);
                                numberTemporary=amountTurned;
                                me.payments[index].amount=me.mymoney(numberTemporary);
                            }else{
                                me.payments[index].amountPaid=me.mymoney(amountPaid);
                                numberTemporary=me.subtraction(amountTurned,amountPaid);
                                me.payments[index].amount=me.mymoney(numberTemporary);
                            }
                        }    
                        // console.log(numberTemporary);
                        me.totalChequer += numberTemporary;
                        listTemporary.push(index);
                        if (me.totalChequer >= me.parseDecimal(me.total)) {
                            me.payments.forEach((item, i) => {
                                if (item.amount === "" || me.parseDecimal(me.converMaskToNumber(item.amount)) <= 0)
                                        me.payments[i].status = 1;
                            });
                            return;
                        } else if (numberTemporary < me.parseDecimal(me.total) && me.totalChequer < me.parseDecimal(me.total)) {
                            me.payments.forEach((item, i) => {
                                if (item.name !== payment.name) {
                                    me.payments[i].status = 0;
                                }
                            });
                            return;
                        }
                    }
                });
            },
            converMaskToNumber(value) {
                var myNumber = "";
                for (var i = 0; i < value.length; i += 1) {
                    if (value.charAt(i) === 'Q' || value.charAt(i) === ',' || value.charAt(i) === ' ') {
                        continue;
                    } else {
                        myNumber += value.charAt(i);
                    }
                }
                return parseFloat(myNumber).toFixed(2);
            },
            saveToPay(){
                let vm=this;
                if(vm.totalString===''){
                    toastr.error('Ingrese un monto a pagar','Error');
                    return;
                }else{
                    if(vm.parseDecimal(vm.converMaskToNumber(vm.totalString))<1){
                        toastr.error('El monto a pagar no puede ser 0','Error');
                        return;    
                    }
                    else if(vm.parseDecimal(vm.converMaskToNumber(vm.totalString))>vm.parseDecimal(vm.loan.balance)){
                        toastr.error('El monto a pagar no puede ser mayor al saldo','Error');
                        return;
                    }else{
                        vm.total=vm.setData(vm.converMaskToNumber(vm.totalString));
                        vm.addAllTypesOfPayments();
                        vm.$refs.modal_loan.close();
                    }
                }

            },
            cancelPay(){
                this.$router.push({path:'/admin/cuentasporpagar/lista'})
            },
            openToPay(){
                this.$refs.modal_loan.open();
            },
            getUser(){
                let vm=this;
                axios.get(`/api/admin/outgoingloan/getUser`)
                    .then((response)=>{
                        vm.user=response.data;
                    }).catch((error)=>{
                        console.log(error)
                    })
            },
        },
        mounted(){
            this.getLoan();
            this.getUser();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/outgoingLoan/outgoingLoan.vue